<template>
    <div id="login" :style='[$vuetify.breakpoint.xs ? {"padding": "30px"} : {"padding": "50px"}]'>
        <v-overlay :value="performingRequest" absolute color="white" opacity=0.9>
                <img
                    src="../assets/images/logo anim.svg"
                    width="100px"
                    height="100px"
                />
        </v-overlay>
        <v-overlay id="error" :value="errorMsg !== ''" opacity=0.9 absolute color='white'>
                <p style="color:black">{{errorMsg}}</p>
                <div class="d-flex justify-content-center">
                    <button id="error-btn" class="btn btn-outline-danger" variant="outline-danger" @click="errorMsg=''">Close</button>
                </div>
        </v-overlay>
        <div
            style="display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center"
        >
            <img
                id="logo"
                src="../assets/images/Aawaaz Logo.png"
                width="200px"
                height="200px"
            />
            <br />
            <v-form v-if="showLoginForm" @submit.prevent>
                <div
                    style="display:flex;flex-direction:column;justify-content:center;align-items:center;"
                >
                    <h1>Aawaaz Portal</h1>
                </div>

                <v-text-field class="mt-7" v-model.trim="loginForm.email" type="email" label="Email" id="email1" required></v-text-field>
                

                <v-text-field class="mb-3" type="password" v-model="loginForm.password" label="Password" id="password1" required></v-text-field>

                
                <div
                    style="display:flex;flex-direction:column;justify-content:center;align-items:center;"
                >
                    <button type="button" id="login-btn" class="btn btn-outline-primary" @click="login">Log In</button>
                    <br />
                    <a @click="togglePasswordReset" id="reset-btn" tabindex="0">Forgot Password</a>
                    <!-- <b-link @click="toggleForm">Create an Account</b-link> -->
                </div>
            </v-form>
            <!-- <b-form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
                <div
                    style="display:flex;flex-direction:column;align-items:center;justify-content:center"
                >
                    <h1>Get Started</h1>
                </div>
                <br />

                <b-form-group label="Name:" label-for="name">
                    <b-form-input
                        id="name"
                        v-model="signupForm.name"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Email address:"
                    label-for="email2"
                    description="We'll never share your email with anyone else."
                >
                    <b-form-input
                        id="email2"
                        v-model.trim="signupForm.email"
                        type="email"
                        required
                    ></b-form-input>
                </b-form-group>

                <label for="password2">Password:</label>
                <b-input
                    type="password"
                    id="password2"
                    v-model.trim="signupForm.password"
                    required
                ></b-input>

                <br />
                <div
                    style="display:flex;flex-direction:column;align-items:center;justify-content:center"
                >
                    <b-button @click="signup">Sign Up</b-button>

                    <br />
                    <b-link @click="toggleForm">Back to Log In</b-link>
                </div>
            </b-form>-->
            <v-form v-if="showForgotPassword" @submit.prevent>
                <div v-if="!passwordResetSuccess">
                    <div
                        style="display:flex;flex-direction:column;justify-content:center;align-items:center"
                    >
                        <h1>Reset Password</h1>
                    </div>

                    <v-form>
                        <v-text-field
                            v-model.trim="passwordForm.email"
                            type="email"
                            required
                            label="Email"
                            class="mt-7"
                        ></v-text-field>
                    </v-form>
                    <div
                        style="display:flex;flex-direction:column;justify-content:center;align-items:center"
                    >
                        <button class='btn btn-outline-primary' @click="resetPassword">Submit</button>
                        <br />
                        <a tabindex="0" @click="togglePasswordReset">Back to Log In</a>
                    </div>
                </div>
                <div v-else>
                    <h1>Email Sent</h1>
                    <p>Check your email for a link to reset your password</p>
                    <button @click="togglePasswordReset" class="btn btn-outline-info">Back to login</button>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
    data() {
        return {
            loginForm: {
                email: "",
                password: ""
            },
            // signupForm: {
            //     name: "",
            //     email: null,
            //     password: null
            // },
            passwordForm: {
                email: ""
            },
            showLoginForm: true,
            showForgotPassword: false,
            passwordResetSuccess: false,
            performingRequest: false,
            errorMsg: "",
            // newUser: false
        };
    },
    mounted: function() {
        document.addEventListener("keydown", event => {
            const loginTriggers = [document.getElementsByTagName("BODY")[0], document.getElementById('email1'), document.getElementById('password1')]
            if (event.keyCode == 13) {
                if (this.errorMsg) {
                    document.getElementById('error-btn').click()
                } else if (this.showLoginForm && loginTriggers.includes(document.activeElement)) {
                    document.getElementById("login-btn").click();
                }
            }
        });

        document.getElementById('reset-btn').addEventListener("keydown", event => {
            if (event.keyCode == 13) {
                document.getElementById('reset-btn').click()
            }
        })
    },
    methods: {
        togglePasswordReset() {
            if (this.showForgotPassword) {
                this.showLoginForm = true;
                this.showForgotPassword = false;
                this.passwordResetSuccess = false;
            } else {
                this.showLoginForm = false;
                this.showForgotPassword = true;
            }
        },
        login() {
            this.performingRequest = true;
            fb.auth
                .signInWithEmailAndPassword(
                    this.loginForm.email,
                    this.loginForm.password
                )
                .then(user => {
                    this.performingRequest = false;
                    this.$router.push("/");
                })
                .catch(err => {
                    console.log(err);
                    this.performingRequest = false;
                    this.errorMsg = err.message;
                });
        },
        // signup() {
        //     this.performingRequest = true;
        //     fb.auth
        //         .createUserWithEmailAndPassword(
        //             this.signupForm.email,
        //             this.signupForm.password
        //         )
        //         .then(user => {
        //             this.newUser = true;
        //             var LoginVue = this;
        //             fb.auth.onAuthStateChanged(function(user) {
        //                 if (user) {
        //                     if (LoginVue.newUser) {
        //                         fb.usersCollection
        //                             .doc(user.uid)
        //                             .set({
        //                                 name: LoginVue.signupForm.name,
        //                                 email: LoginVue.signupForm.email,
        //                                 profilePicUrl:
        //                                     "https://randomuser.me/api/portraits/lego/1.jpg",
        //                                 classes: [],
        //                                 type:'student',
        //                                 timestamp: fb.firebase.firestore.Timestamp.now()
        //                             })
        //                             .then(() => {
        //                                 LoginVue.$store.dispatch(
        //                                     "fetchUserProfile"
        //                                 );
        //                                 LoginVue.newUser = false
        //                                 LoginVue.performingRequest = false;
        //                                 LoginVue.$router.push("/");
        //                             })
        //                             .catch(err => {
        //                                 console.log(err);
        //                                 LoginVue.performingRequest = false;
        //                             });
        //                     }
        //                 }
        //             });
        //         })
        //         .catch(err => {
        //             console.log(err)
        //             this.errorMsg = err.message;
        //         });
        // },
        toggleForm() {
            this.showLoginForm = !this.showLoginForm;
        },
        resetPassword() {
            this.performingRequest = true;

            fb.auth
                .sendPasswordResetEmail(this.passwordForm.email)
                .then(() => {
                    this.performingRequest = false;
                    this.passwordResetSuccess = true;
                    this.passwordForm.email = "";
                })
                .catch(err => {
                    console.log(err);
                    this.performingRequest = false;
                    this.errorMsg = err.message;
                });
        }
    }
};
</script>